module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/2mill-inactive-24b8100ac3a65c940802d579d5f769f0.png";